module.exports = "/** No CSS for this example */\r\nmat-slider {\r\n  width: 300px;\r\n}"